import { Trans, useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import BgPattern from '~/landing/components/BgPattern'
import FeatureSection from '~/start/components/FeatureSection'
import { useLandingEntryRoute } from '~/landing/contexts/landingEntryRoute'
import StartAnalytics from '~/analytics/start/startAnalytics'
import Button from '~/components/Buttons/Button'

export default function MindSectionMobile({
  buttonClassName,
  onClick,
}: {
  buttonClassName?: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}): React.ReactElement {
  const { t } = useTranslation('landing')
  const entryRoute = useLandingEntryRoute()

  const handleButtonClick = (): void => {
    StartAnalytics.logCtaClick('onboarding_cta', 'landing_section_2_cta')
  }

  return (
    <div className="relative flex flex-col justify-center items-center px-2 pt-2 pb-12 text-center text-white">
      <BgPattern />
      <ResponsiveImage
        className="absolute min-w-196 w-full max-w-302 ml-[600px] -mt-20"
        height={886}
        imageClassName="object-contain"
        srcKey="landing/pad-pattern.png"
        width={1378}
      />
      <ResponsiveImage
        className="absolute z-10 min-w-196 -left-[450px] rotate-90 opacity-20"
        height={600}
        srcKey="landing/mind-ai-v2.png"
        width={600}
      />
      <div className="pb-12">
        <p className="text-md text-blue-pastel py-4">{t('mindAI.backed')}</p>
        <h1 className="text-6 font-bold max-w-screen-19/20 leading-tight">
          {Trans({
            t,
            i18nKey: 'mindAI.title',
            components: { pink: <span className="text-blue-pastel" /> },
            children: t('sagaPrivate.title'),
          })}
        </h1>
      </div>
      <div className="flex flex-col gap-6 z-10 mb-4">
        <ResponsiveImage
          className="absolute min-w-20 -right-4 -mt-12 z-10"
          height={32}
          imageClassName="min-w-20"
          srcKey="landing/mini-box-2.png"
          width={100}
        />
        <ResponsiveImage
          className="absolute min-w-168 -mt-12 -ml-8"
          height={230}
          imageClassName="min-w-168"
          srcKey="landing/text-box-1.png"
          width={800}
        />
        <div className="relative z-10 max-w-75 text-left ml-18 -mt-3 leading-tight">
          <p className="text-blue-pastel text-5 font-bold whitespace-nowrap">{t('mindAI.map')}</p>
          <p>{t('mindAI.analyzeKnowledge')}</p>
        </div>
      </div>
      <div className="flex flex-col gap-6 z-10 mt-8">
        <ResponsiveImage
          className="absolute min-w-168"
          height={230}
          imageClassName="min-w-168"
          srcKey="landing/bg-image-3.png"
          width={1010}
        />
        <div className="relative z-10 max-w-75 text-left ml-14 mt-2.5">
          <p className="text-blue-pastel text-5 font-bold whitespace-nowrap">{t('mindAI.personalizesLearning')}</p>
          <p>{t('mindAI.personalizedRecipes')}</p>
        </div>
      </div>
      <div className="flex flex-col gap-6 z-10 my-6">
        <ResponsiveImage
          className="absolute min-w-168"
          height={230}
          imageClassName="min-w-168"
          srcKey="landing/bg-image-1.png"
          width={800}
        />
        <div className="relative z-10 max-w-75 text-left ml-24 mt-7">
          <p className="text-blue-pastel text-5 font-bold whitespace-nowrap">{t('mindAI.adaptsRealTime')}</p>
          <p>{t('mindAI.constantlyLearning')}</p>
        </div>
      </div>
      <Button
        className={
          buttonClassName
            ? buttonClassName
            : '!bg-green-lime !text-black border-4 rounded-full px-8 py-2 text-md !font-black hover:scale-110 duration-100 z-10'
        }
        href={onClick ? undefined : entryRoute}
        onClick={onClick || handleButtonClick}
      >
        {t('testimonials.turnStruggle')}
      </Button>
      <div className="flex z-10">
        <FeatureSection isMobile={false} />
      </div>
    </div>
  )
}
